
const checkPermission = (module, subModule, operationCode) => {
  const userPermissions = JSON.parse(sessionStorage.getItem("cachedPermission")) || [];
  //const userRole = sessionStorage.getItem("role") || "GUEST"; // Default to GUEST if no role

  // Find if the user has a permission entry matching module & subModule
  const permission = userPermissions.find(
    (perm) => perm.module === module && perm.subModule === subModule
  );

  if (!permission) {
    return false; // No matching module & subModule found
  }

  // Convert operationCode string to an array
  const allowedOperations = permission.operationCode.split(",");

  return allowedOperations.includes(operationCode);
};

export default checkPermission;
